import { Form, Select } from 'antd';
import { useState } from 'react';

import useProductStore from '@/features/Product/store/ProductStore';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const BrandField = (props: { required?: boolean }) => {
  const { required = false } = props;
  const brandMap = useProductStore((state) => state.brandMap);

  const [tempBrandOptions, setTempBrandOptions] = useState<string[]>(
    Array.from(brandMap.values()).map((brand) => brand.name),
  );

  return (
    <>
      {/* Hidden Form.Item for actual value storage */}
      <Form.Item
        name={SCRAPER_REQ_FIELD_KEY.BRAND}
        required={required}
        rules={
          required ? [{ required: true, message: 'Brand is required' }] : []
        }
        hidden
      >
        <input />
      </Form.Item>

      {/* Display Form.Item with render function */}
      <Form.Item label="Brand" shouldUpdate required={required}>
        {({ getFieldValue, setFieldValue }) => {
          const currentBrand: string = getFieldValue(
            SCRAPER_REQ_FIELD_KEY.BRAND,
          );
          return (
            <Select
              value={currentBrand ? [currentBrand] : []}
              options={tempBrandOptions.map((value) => ({
                label: value,
                value,
              }))}
              placeholder="Select brand"
              mode="tags"
              maxTagCount={1}
              onSelect={(value) => {
                setFieldValue(SCRAPER_REQ_FIELD_KEY.BRAND, value);
                if (value && !tempBrandOptions.includes(value)) {
                  setTempBrandOptions((prev) => [...prev, value]);
                }
              }}
              onDeselect={() => {
                setFieldValue(SCRAPER_REQ_FIELD_KEY.BRAND, '');
              }}
            />
          );
        }}
      </Form.Item>
    </>
  );
};
